import {useState} from 'react';
import {useInstance} from 'react-ioc';
import {useParams} from 'react-router';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {useQuery} from '@apollo/client';
import {Button, Select, Space} from 'antd';
import cn from 'classnames';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {Store} from '../../../model/store/Store';
import {position, positionVariables} from '../../../shared/graphql/__generated__/position';
import {positions, positionsVariables} from '../../../shared/graphql/__generated__/positions';
import {QUERY_POSITION, QUERY_POSITIONS} from '../../../shared/graphql/position';
import {CurrencyFormat} from '../../../shared/helpers/CurrencyFormat';
import {fullUrl} from '../../../shared/helpers/fullUrl';
import {Card} from '../Category/Card';
import {Tag} from '../Category/Tag';

import cls from './Product.module.scss'

export const Product = observer(() => {

    const [img, setImg] = useState<string>('');
    const [selectedAromaId, setSelectedAromaId] = useState<string | null>(null);
    const {order} = useInstance(Store)

    const {id} = useParams()
    const query = useQuery<position, positionVariables>(QUERY_POSITION, {
        variables: {
            documentId: id!
        },
        onCompleted: (data) => {
            setImg(data.position?.cover.url!)
            const firstAroma = data.position?.aromas?.find(Boolean)
            if (firstAroma?.documentId) setSelectedAromaId(firstAroma.documentId)
        }
    })

    const recomend = useQuery<positions,positionsVariables>(QUERY_POSITIONS, {
        variables: {
            filters: {
                documentId: {ne: id},
                collections: {documentId: {in: _.map(query.data?.position?.collections, item => item?.documentId!)}}
            },
            pagination: {
                limit: 4,
            }
        },
    })
    // console.log(recomend.data?.positions)

    const addToCart = () => {
        order.addPosition(
            query.data?.position?.documentId!,
            query.data?.position?.cover.url!,
            query.data?.position?.name!,
            query.data?.position?.price!,
            selectedAromaId ?? undefined,
            selectedAroma?.name,
        )
    }

    const plus = () => {
        order.plusQuantity(query.data?.position?.documentId!, selectedAromaId ?? undefined)
    }
    const minus = () => {
        order.minusQuantity(query.data?.position?.documentId!, selectedAromaId ?? undefined)
    }

    const current = _.find(
        order.positions,
        (p) => p.documentId === query.data?.position?.documentId && (p.aromaDocumentId ?? '') === (selectedAromaId ?? '')
    )

    const aromaOptions = _.map(
        _.filter(query.data?.position?.aromas, Boolean),
        (item) => ({ value: item!.documentId, label: item!.name })
    );
    const selectedAroma = _.find(query.data?.position?.aromas, (a) => a?.documentId === selectedAromaId);
    const addToCartDisabled = aromaOptions.length > 0 && !selectedAromaId;

    return (
        <div className={cls.page}>
            <div className={cls.product}>
                <div className={cls.gallery}>
                    <div className={cls.thumbs}>
                        <div className={cn([cls.thumb, img === query.data?.position?.cover.url && cls.selected])}
                             onClick={() => setImg(query.data?.position?.cover.url!)}>
                            <img src={fullUrl(query.data?.position?.cover.url!)} alt="Cover" className={cls.thumb_img}/>
                        </div>
                        {_.map(query.data?.position?.photos, (item) => (
                            <div key={item?.documentId} className={cn([cls.thumb, img === item?.url && cls.selected])}
                                 onClick={() => setImg(item?.url!)}>
                                <img src={fullUrl(item?.url!)} alt="Cover" className={cls.thumb_img}/>
                            </div>
                        ))}
                    </div>
                    <div className={cls.cover}>
                        <img src={fullUrl(img)} alt="Daisy" className={cls.img}/>
                        {/*<div className={cls.img} style={{backgroundImage: `url(${fullUrl(img)})`}}/>*/}
                    </div>
                </div>
                <div className={cls.content}>
                    {query.data?.position?.article && <div>{query.data?.position?.article}</div>}
                    {query.data?.position?.collections.length! > 0 &&
                        <div className={cls.tags}>
                            {_.map(query.data?.position?.collections, (item) => (
                                <div key={item?.documentId}>{item?.name}</div>
                            ))}
                        </div>
                    }
                    {(query.data?.position?.new ||
                            query.data?.position?.hit ||
                            query.data?.position?.pre_order) &&
                        <div className={cls.tags}>
                            {query.data?.position?.hit && <Tag type={'hit'}/>}
                            {query.data?.position?.new && <Tag type={'new'}/>}
                            {query.data?.position?.pre_order && <Tag type={'pre_order'}/>}
                        </div>}
                    <h1>{query.data?.position?.name}</h1>
                    {/*{query.data?.position?.aroma && <h3>{query.data?.position?.aroma}</h3>}*/}
                    {query.data?.position?.structure && <div>{query.data?.position?.structure}</div>}
                    {query.data?.position?.volume && <div>{query.data?.position?.volume}</div>}
                    <div>{query.data?.position?.description}</div>
                    {aromaOptions.length > 0 && (
                        <div className={cls.aromas}>
                            <h3>Вариант аромата:</h3>
                            <Select
                                style={{ width: '100%'}}
                                placeholder="Выберите аромат"
                                options={aromaOptions}
                                value={selectedAromaId ?? undefined}
                                onChange={setSelectedAromaId}
                            />
                            {selectedAroma?.description && (
                                <>
                                    <div>{selectedAroma.description}</div>
                                </>
                            )}
                            {selectedAroma?.group && (
                                <>
                                    <h3>Группа</h3>
                                    <div>{selectedAroma.group}</div>
                                </>
                            )}
                            {selectedAroma?.notes && (
                                <>
                                    <h3>Ноты аромата</h3>
                                    <div className={cls.notes}>{selectedAroma.notes}</div>
                                </>
                            )}
                        </div>
                    )}
                    <div className={cls.line}>
                        <Space size={20}>
                            <div className={cls.price}>{CurrencyFormat(query.data?.position?.price!)} ₽</div>
                            {query.data?.position?.old_price && <div className={cls.old_price}>{CurrencyFormat(query.data?.position?.old_price!)} ₽</div>}
                        </Space>
                        <div>
                            {current && current.quantity > 0 ?
                                <Space size={16}>
                                    <Button type={'primary'} onClick={minus} icon={<MinusOutlined/>} shape={'circle'}/>
                                    <span>{current?.quantity} шт.</span>
                                    <Button type={'primary'} onClick={plus} icon={<PlusOutlined/>} shape={'circle'}/>
                                </Space>
                            :
                                <Button type={'primary'} onClick={addToCart} disabled={addToCartDisabled}>В корзину</Button>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div>
                <h2>Еще из этой коллекции</h2>
                <div className={cls.table}>
                    {_.map(recomend.data?.positions, item => (
                        <Card key={item?.documentId} id={item?.documentId!} name={item?.name!} price={item?.price!}
                              tag_hit={item?.hit!} tag_new={item?.new!} tag_pre_order={item?.pre_order!}
                              cover={item?.cover.url!} aromas={item?.aromas ?? undefined}/>
                    ))}
                </div>
            </div>
        </div>
    )

})